export function folderStorageKey(owner) {
  return `lunadesk.tasks.folders.open.v1.${owner}`;
}
export function readFolderState(key) {
  try {
    const value = JSON.parse(localStorage.getItem(key) || '{}');
    if (!value || Array.isArray(value) || typeof value !== 'object') return {};
    return Object.fromEntries(Object.entries(value).filter(([, open]) => typeof open === 'boolean').slice(0, 10000));
  } catch { return {}; }
}
export function applyFolderState(tree, state) {
  return tree.map(node => node.type === 'folder' ? {
    ...node,
    open: Object.prototype.hasOwnProperty.call(state, String(node.id)) ? state[String(node.id)] : node.open,
    children: applyFolderState(node.children || [], state),
  } : node);
}
export function saveFolderState(key, tree) {
  const state = {};
  function visit(nodes) {
    for (const node of nodes) if (node.type === 'folder') {
      state[String(node.id)] = node.open === true;
      visit(node.children || []);
    }
  }
  visit(tree);
  try { localStorage.setItem(key, JSON.stringify(state)); } catch { /* Navigation still works without storage. */ }
}
